import styled, { keyframes } from 'styled-components'

const flowRightToLeft = keyframes`
  0% {
    background-position: 100% 0%;
  }
  100% {
    background-position: -100% 0%;
  }
`

const flowLeftToRight = keyframes`
  0% {
    background-position: -100% 0%;
  }
  100% {
    background-position: 100% 0%;
  }
`

const FandomLogoLoop = styled.div`
  width: 100vw;
  height: 53px;
  background-image:
    url('/images/FandomLogos.svg'),
    linear-gradient(
      to right,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 1) 10%,
      rgba(255, 255, 255, 1) 90%,
      rgba(255, 255, 255, 0) 100%
    );
  background-size:
    auto 100%,
    100% 100%;
  background-repeat: repeat-x;
  animation: ${flowLeftToRight} 20s linear infinite;
  mask-image: linear-gradient(
    to right,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 1) 10%,
    rgba(0, 0, 0, 1) 90%,
    rgba(0, 0, 0, 0) 100%
  );
  -webkit-mask-image: linear-gradient(
    to right,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 1) 10%,
    rgba(0, 0, 0, 1) 90%,
    rgba(0, 0, 0, 0) 100%
  );

  @media (max-width: 640px) {
    width: 100vw;
    height: 40px;
    animation: ${flowLeftToRight} 30s linear infinite;
  }
`

const FandomLogoLoopReversed = styled.div`
  width: 100vw;
  height: 53px;
  background-image:
    url('/images/FandomLogos.svg'),
    linear-gradient(
      to left,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 1) 10%,
      rgba(255, 255, 255, 1) 90%,
      rgba(255, 255, 255, 0) 100%
    );
  background-size:
    auto 100%,
    100% 100%;
  background-repeat: repeat-x;
  animation: ${flowRightToLeft} 20s linear infinite;
  mask-image: linear-gradient(
    to left,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 1) 10%,
    rgba(0, 0, 0, 1) 90%,
    rgba(0, 0, 0, 0) 100%
  );
  -webkit-mask-image: linear-gradient(
    to left,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 1) 10%,
    rgba(0, 0, 0, 1) 90%,
    rgba(0, 0, 0, 0) 100%
  );

  @media (max-width: 640px) {
    width: 100vw;
    height: 40px;
    animation: ${flowRightToLeft} 30s linear infinite;
  }
`

export { FandomLogoLoop, FandomLogoLoopReversed }
